<template>
  <div class="header-component mb8 flex-row p16 width100">
    <!-- Start HOOK_TOP -->
    <i class="hkfi-back fs-14 bold mr12" @click="handleBackButtonClick"></i>
    <home-page-user-address :fullWidth="true"></home-page-user-address>
    <!-- <profile-icon></profile-icon> -->
    <!-- eof HOOK_TOP -->
  </div>
</template>

<script>
import Utility from "../helpers/utility";
import ProfileIcon from "./ProfileIcon.vue";
import HomePageUserAddress from "./HomePageUserAddress.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";

export default {
  name: "TakeAwayPageHeader",
  components: {
    ProfileIcon,
    HomePageUserAddress,
  },
  data() {
    return {};
  },
  mounted() {
    if (this.isChangeTriggeredFromTakeawayDinein) {
      let item = LocalStorageFunc.getSelectedChangedLocationForTwyDinein();
      let query = {
        place_id: item.placeId,
      };
      this.$store.dispatch(keyMapsAction.GEO_CODE_API, query).then((res) => {
        if (res.data.status === "SUCCESS") {
          if (res.data?.results[0]) {
            let pos = res.data.results[0].geometry.location;
            this.$store.dispatch(keyMapsAction.LOCATOR_STORE_TAKEAWAY_API, {
              latitude: pos.lat,
              longitude: pos.lng,
            });

            this.$store.commit(
              keyMapsMutation.UPDATE_SHOW_DELIVERY_MAP_SCREEN,
              false
            );
            this.$store.commit(
              keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
              false
            );

            LocalStorageFunc.updateLastLocationOnConfirmedLocation();
          }
        }
      });
    }
  },
  methods: {
    handleBackButtonClick(e) {
      if (
        !LocalStorageFunc.getDeliveryTypeStationData() ||
        (LocalStorageFunc.getDeliveryTypeStationData() &&
          !Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length)
      ) {
        LocalStorageFunc.setDeliveryType("D");
        this.$store.commit(keyMapsMutation.UPDATE_CURRENT_ORDER_TYPE, "D");
      } else {
        LocalStorageFunc.setDeliveryType(
          this.$store.state.User.currentOrderType
        );
      }
      LocalStorageFunc.setSelectedChangedLocationForTwyDinein({});
      Utility.redirectToHomeOrRedirectUrl([
        { name: "changeTriggerFromDineinTwy", value: false },
      ]);
    },
  },
  watch: {},
  computed: {
    isChangeTriggeredFromTakeawayDinein() {
      let queryParams = Utility.getQueryFromUrl();
      return queryParams["changeTriggerFromDineinTwy"] == "true" || false;
    },
  },
};
</script>

<style></style>
